import * as Babel from '@babel/standalone'
import less from 'less'
import SVG from './svg'

export default class Compiler {
    async compileVue(scope, template) {
        //try {
            let parser = new DOMParser()
            let doc = parser.parseFromString(template, "text/html")
            let tmpl = this.getTmpl(template)
            let script = _.get(doc.querySelector("script"), 'textContent', '')
            let code = Babel.transform(script, { sourceType: "module", presets: ["env"] }).code
            let styles = _.get(doc.querySelector("style"), 'textContent', '')
            let css = await this.compileCSS(scope, styles)

            return {
                template: tmpl,
                style:  css.css,
                script: code
            }
        // } catch(err) {
        //     throw new Error(err.message)
        // }
    }

    getStringBetween(str, start, end) {
        const result = str.match(new RegExp("(?:\\" + start +")(.*)(?=\\" + end + ")", 'gs'));

        if (result === null) {
            return ""
        }

        return result[0].replace(start, "");
    }

    getTmpl(c) {
        try {
            return this.getStringBetween(c, "<tmpl>","</tmpl>");
        } catch(err) {
            throw new Error("Failed to parse template:" + err.message)
        }
    }

    compileJSFromTemplate(vars) {
        let contents = this.contents(this.template)
        return this.compileJS(contents.script, vars)
    }

    compileJS(expression) {
        let code = Babel.transform(expression, { sourceType: "module", presets: ["env"] })
        return code.code
    }

    async compileCSS(scope, styles) {
        if (scope) {
            return await less.render(`.${scope} { ${styles} }`)
        }

        return await less.render(`${styles}`)
    }

    evaluateJS(expression, vars) {
        console.log("evaluteJS", expression)
        
        let keys = Object.keys(vars)
        let values = Object.values(vars)

        let result = new Function(...keys, `${expression} ; return exports;`)

        return result(...values)
    }

    transpileSVG(content) {
        let svg = new SVG(content)
        return svg.transpile()
    }
}